'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* Sourced from the O-Brain client page (Avoma + Linear + HubSpot, last processed 2026-09-10) and the implementation tracker. DELIBERATELY ABSENT: the ~44% handling rate (the source says spam and assignment constraints distort it), the resolved-ticket counts (flagged as overstated), and every commercial figure. None of those may become a claim here.
 *
 * No stats row and no results table: no cleared figure exists for Banqy.
 * Add the stats, the table and the six-place number check from the
 * customer-stories skill in the same commit that lands real numbers. */
const BanqyCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Banqy"
        title={t.customerStories['banqy_hero_title']}
        subtitle={t.customerStories['banqy_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-banqy.svg',
          logoAlt: 'Banqy',
          customerName: 'Banqy',
          company: t.customerStories['banqy_company_description'],
          industry: t.customerStories['banqy_industry'],
          websiteUrl: 'https://banqy.ae',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['banqy_location'],
            },
          ],
          keyResults: [
            t.customerStories['banqy_key_result_1'],
            t.customerStories['banqy_key_result_2'],
            t.customerStories['banqy_key_result_3'],
            t.customerStories['banqy_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['banqy_intro']}</p>

        <h2>{t.customerStories['banqy_challenge_title']}</h2>
        <p>{t.customerStories['banqy_challenge_p1']}</p>
        <p>{t.customerStories['banqy_challenge_p2']}</p>
        <p>{t.customerStories['banqy_challenge_p3']}</p>

        <h2>{t.customerStories['banqy_solution_title']}</h2>
        <p>{t.customerStories['banqy_solution_p1']}</p>
        <p>{t.customerStories['banqy_solution_p2']}</p>
        <p>{t.customerStories['banqy_solution_p3']}</p>
        <p>{t.customerStories['banqy_solution_p4']}</p>

        <h2>{t.customerStories['banqy_impact_title']}</h2>
        <p>{t.customerStories['banqy_impact_p1']}</p>
        <p>{t.customerStories['banqy_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default BanqyCaseStudy;
